// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form__container-c4f025 {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.Form__form-ef2c2f {
  overflow: auto;
  height: 100%;
  padding: 0 16px;
}

.Form__switch-e4db67 {
  padding: 12px 24px;
}

.Form__container-date-range-e07eed {
  display: flex;
  gap: 4px;
}

.Form__divider-a59c5d,
.Form__title-ad94d5 {
  display: flex;
  height: 52px;
  align-items: center;
}

.Form__title-ad94d5 {
  width: 100%;
  font: var(--font-body-4);
  color: var(--base-110);
}

.Form__reminder-f698b0,
.Form__repeat-b87cc9 {
  margin-top: 4px;
  margin-bottom: 20px;
  width: 100%;
}

.Form__repeat-b87cc9 {
  margin-top: 24px;
}

.Form__checkbox-ad53e8 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.Form__container-start-date-ff9fad,
.Form__container-end-date-f98c11 {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.Form__footer-cbdd95 {
  display: flex;
  min-height: 56px;
  align-items: center;
  justify-content: end;
}

.Form__footer-button-a6e364 {
  margin: 16px;
}

.Form__field-autocomplete-da7941 {
  margin-top: 4px;
}

.Form__field-description-f851d2 {
  height: auto;
}

.Form__error-message-a3518e {
  min-height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--danger-40);
  padding: 8px 12px 0px 12px;
}

.Form__top-side-cef41a {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 13px 16px;
}

.Form__minimized-title-container-f37687 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.Form__minimized-title-e36d66 {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-inline-end: 12px;
  flex: 1;
}

.Form__minimized-time-b01b9b {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-80);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-inline-end: 12px;
  flex: 1;
}

.Form__bottom-side-ba80d8 {
  display: flex;
  flex-direction: row-reverse;
  margin: 16px;
}

.Form__error-message-a3518e {
  padding: 4px 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/Form.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;;EAEE,aAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,wBAAA;EACA,sBAAA;AACF;;AAEA;;EAEE,eAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,2BAAA;EACA,6CAAA;EACA,uBAAA;EACA,0BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;EACA,YAAA;AACF;;AAGA;EACE,kBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.form {\n  overflow: auto;\n  height: 100%;\n  padding: 0 16px;\n}\n\n.switch {\n  padding: 12px 24px;\n}\n\n.container-date-range {\n  display: flex;\n  gap: 4px;\n}\n\n.divider,\n.title {\n  display: flex;\n  height: 52px;\n  align-items: center;\n}\n\n.title {\n  width: 100%;\n  font: var(--font-body-4);\n  color: var(--base-110);\n}\n\n.reminder,\n.repeat {\n  margin-top: 4px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.repeat {\n  margin-top: 24px;\n}\n\n.checkbox {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n}\n\n.container-start-date,\n.container-end-date {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.footer {\n  display: flex;\n  min-height: 56px;\n  align-items: center;\n  justify-content: end;\n}\n\n.footer-button {\n  margin: 16px;\n}\n\n.field-autocomplete {\n  margin-top: 4px;\n}\n\n.field-description {\n  height: auto;\n}\n\n.error-message {\n  min-height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--danger-40);\n  padding: 8px 12px 0px 12px;\n}\n\n.top-side {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 13px 16px;\n}\n\n.minimized-title-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.minimized-title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-inline-end: 12px;\n  flex: 1;\n}\n\n.minimized-time {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-80);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-inline-end: 12px;\n  flex: 1;\n}\n\n.bottom-side {\n  display: flex;\n  flex-direction: row-reverse;\n  margin: 16px;\n}\n\n\n.error-message {\n  padding: 4px 0 0 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Form__container-c4f025`,
	"form": `Form__form-ef2c2f`,
	"switch": `Form__switch-e4db67`,
	"container-date-range": `Form__container-date-range-e07eed`,
	"containerDateRange": `Form__container-date-range-e07eed`,
	"divider": `Form__divider-a59c5d`,
	"title": `Form__title-ad94d5`,
	"reminder": `Form__reminder-f698b0`,
	"repeat": `Form__repeat-b87cc9`,
	"checkbox": `Form__checkbox-ad53e8`,
	"container-start-date": `Form__container-start-date-ff9fad`,
	"containerStartDate": `Form__container-start-date-ff9fad`,
	"container-end-date": `Form__container-end-date-f98c11`,
	"containerEndDate": `Form__container-end-date-f98c11`,
	"footer": `Form__footer-cbdd95`,
	"footer-button": `Form__footer-button-a6e364`,
	"footerButton": `Form__footer-button-a6e364`,
	"field-autocomplete": `Form__field-autocomplete-da7941`,
	"fieldAutocomplete": `Form__field-autocomplete-da7941`,
	"field-description": `Form__field-description-f851d2`,
	"fieldDescription": `Form__field-description-f851d2`,
	"error-message": `Form__error-message-a3518e`,
	"errorMessage": `Form__error-message-a3518e`,
	"top-side": `Form__top-side-cef41a`,
	"topSide": `Form__top-side-cef41a`,
	"minimized-title-container": `Form__minimized-title-container-f37687`,
	"minimizedTitleContainer": `Form__minimized-title-container-f37687`,
	"minimized-title": `Form__minimized-title-e36d66`,
	"minimizedTitle": `Form__minimized-title-e36d66`,
	"minimized-time": `Form__minimized-time-b01b9b`,
	"minimizedTime": `Form__minimized-time-b01b9b`,
	"bottom-side": `Form__bottom-side-ba80d8`,
	"bottomSide": `Form__bottom-side-ba80d8`
};
module.exports = ___CSS_LOADER_EXPORT___;
